<template>
  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-1" role="tab">
      <b-button
        href="#"
        v-b-toggle="'accordion-' + collapseKey"
        class="bg-main w-100 text-white"
        :id="`accordion-${collapseKey}`"
        >{{ name }}</b-button
      >
    </b-card-header>
    <b-collapse :id="'accordion-' + collapseKey" visible accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <b-card-text>
          <span v-html="$sanitize(description)"></span>
        </b-card-text>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    collapseKey: {
      type: [String, Number],
      default: '',
      require: true,
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang=""></style>

